import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { ControlButtons } from '../../../components'


const mapStateToProps = (state, ownProps) => {
  const { moves, movesHistory, movesAnalyze, analyzeStartNum, cardWidth, isAnalyzeMode, isPlayMode } = state.renjuBoardCards.cards[ownProps.bid]
  var enableRewind, enableForward, buttonSize, number
  enableRewind = false
  enableForward = false
  number = Math.max(...moves.map(move => move.number))
  if (isAnalyzeMode){
    enableRewind  = Boolean(moves.length - analyzeStartNum - 1 > 0);
    enableForward = Boolean(moves.length < movesAnalyze.length);
  }
  else {
    enableRewind  = Boolean(number > 0);
    enableForward = Boolean(moves.length < movesHistory.length);
  }

  buttonSize = {
    width: '48px',
    height: '48px',
  }

  if (cardWidth <= 330) {
    buttonSize.width = '35px';
    buttonSize.height = '35px';
  }

  return ({
    isPlayMode,
    buttonSize,
    enableRewind,
    enableForward,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { bid } = ownProps
  return ({
    handleClickPlay: (event) => {
      dispatch(actions.controlButtons.startPlay(bid))
    },
    handleClickStop: (event) => {
      dispatch(actions.controlButtons.stopPlay(bid))
    },
    handleClickSkipPrevious: (event) => {
      dispatch(actions.controlButtons.skipPrevious(bid))
    },
    handleClickFastRewind: (event) => {
      dispatch(actions.controlButtons.fastRewind(bid))
    },
    handleClickFastForward: (event) => {
      dispatch(actions.controlButtons.fastForward(bid))
    },
    handleClickSkipNext: (event) => {
      dispatch(actions.controlButtons.skipNext(bid))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControlButtons)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/ControlButtons.js